export const range = (start, end) => Array(end + 1 - start)
    .fill(null)
    .map((_, i) => start + i);
const numberWithUnitRegex = /([0-9,\.]+)\s?(\S+)/;
export const parseUnitNum = (timeStr) => { var _a, _b; return Number((_b = (_a = timeStr.match(numberWithUnitRegex)) === null || _a === void 0 ? void 0 : _a[1]) === null || _b === void 0 ? void 0 : _b.replace(',', '')); };
export const parseUnit = (timeStr) => { var _a, _b; return (_b = (_a = timeStr.match(numberWithUnitRegex)) === null || _a === void 0 ? void 0 : _a[2]) !== null && _b !== void 0 ? _b : undefined; };
